// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiRequestSearchBase {
    static getAttributeTypeMap() {
        return PharmacyBiRequestSearchBase.attributeTypeMap;
    }
}
PharmacyBiRequestSearchBase.discriminator = undefined;
PharmacyBiRequestSearchBase.additionalProperties = false;
PharmacyBiRequestSearchBase.attributeTypeMap = [
    {
        "name": "request",
        "baseName": "request",
        "type": "PharmacyBiRequestBase"
    },
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "transactionDateTime",
        "baseName": "transactionDateTime",
        "type": "Date"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "transactionStatus",
        "baseName": "transactionStatus",
        "type": "boolean"
    },
    {
        "name": "customerId",
        "baseName": "customerId",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiRequestSearchBase.js.map